import { makeAutoObservable, toJS } from 'mobx';

import diff from '@/common/helpers/diff';
import Sort from '@/common/state/Sort';
import { SortDirection } from '@/common/types/sort';
import SetupPreset from '@/media/entity/SetupPreset';
import SetupPresetGroup from '@/media/entity/SetupPresetGroup';
import { ProductType } from '@/product/constants/productTypes';

import { ViewTemplateType } from '../constants/viewTemplateTypes';

interface ViewTemplateModel {
  id: number;
  title: string;
  sort: Record<string, SortDirection>;
  cardFields: string[];
  isHiddenDesc: boolean;
  isSingleScale: boolean;
  isGrayscale: boolean;
  isSaturation: boolean;
  type: number[];
  context: number[];
}

export default class ViewTemplate implements Omit<ViewTemplateModel, 'sort'> {
  id: number;

  title: string;

  setupPreset: Nullable<SetupPreset>;

  setupPresetGroup: Nullable<SetupPresetGroup>;

  sort: Sort;

  cardFields: string[];

  isHiddenDesc: boolean;

  isSingleScale: boolean;

  isGrayscale: boolean;

  isSaturation: boolean;

  type: number[];

  context: number[];

  static getTypeByProductType(productType: ProductType) {
    if (productType === ProductType.Rough || productType === ProductType.LGDRough) {
      return ViewTemplateType.Rough;
    }

    if (productType === ProductType.Jewelry) {
      return ViewTemplateType.Jewelry;
    }

    if (productType === ProductType.DiamondFancy) {
      return ViewTemplateType.Fancy;
    }

    if (productType === ProductType.Gem) {
      return ViewTemplateType.Gem;
    }

    return ViewTemplateType.Colorless;
  }

  constructor(
    modelData: ViewTemplateModel,
    setupPreset: Nullable<SetupPreset> = null,
    setupPresetGroup: Nullable<SetupPresetGroup> = null,
  ) {
    makeAutoObservable(this, {
      context: false,
    });

    this.id = modelData.id;
    this.title = modelData.title;
    this.sort = Sort.fromJSON(modelData.sort);
    this.cardFields = modelData.cardFields;
    this.setupPreset = setupPreset;
    this.setupPresetGroup = setupPresetGroup;
    this.isHiddenDesc = modelData.isHiddenDesc;
    this.isSingleScale = modelData.isSingleScale;
    this.isGrayscale = modelData.isGrayscale;
    this.isSaturation = modelData.isSaturation;
    this.type = modelData.type;
    this.context = modelData.context;
  }

  diff(otherObject: ViewTemplateModel) {
    return diff(toJS(this), toJS(otherObject));
  }
}
